import React, {useContext, useEffect} from 'react';
import {injectIntl} from "react-intl";

import {useFormikContext} from "formik";

import Grid from "@mui/material/Grid";

import CustomCheckbox from "components/checkbox/CustomCheckbox";

import ReturnShippingMethodOverrideField from "./ReturnShippingMethodOverrideField";

import {ShippingMethodFormContext} from "../../context/ShippingMethodFormContext";

function ReturnWaybillFields(props) {
    const {isReturnWaybill, setIsReturnWaybill} = useContext(ShippingMethodFormContext);
    const {validateField} = useFormikContext()

    // trigger validation of return waybill field
    useEffect(() => {
        validateField('printConfig');
    }, [isReturnWaybill]);

    return (
        <Grid item>
            <Grid container rowSpacing={3}>
                <Grid item>
                    <CustomCheckbox
                        noPadding
                        label={props.intl.formatMessage({id: 'shippingMethods.form.returnWaybill.label'})}
                        checked={isReturnWaybill}
                        onChange={() => setIsReturnWaybill(!isReturnWaybill)}
                    />
                </Grid>
                {isReturnWaybill && (
                    <Grid item xs={12}>
                        <ReturnShippingMethodOverrideField />
                    </Grid>
                )}
            </Grid>
        </Grid>
    );
}

export default injectIntl(ReturnWaybillFields);
